import { render } from "./List.vue?vue&type=template&id=4388c928&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=4388c928&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4388c928"

export default script